/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const GRID_LAYOUT_GAP = 16;

export const GRID_LAYOUT_MIN_ROW_HEIGHT = 15;
export const GRID_LAYOUT_DEFAULT_ROW_HEIGHT = 75;

export const GRID_LAYOUT_MIN_COLS = 12;
export const GRID_LAYOUT_VISIBLE_ROWS = 12;
export const GRID_LAYOUT_MAX_ROWS = GRID_LAYOUT_VISIBLE_ROWS * 5;

export const GRID_LAYOUT_ITEM_MIN_COLS = 2;
export const GRID_LAYOUT_ITEM_MIN_ROWS = 2;
